"use client";
import { useEffect } from "react";
import { motion, stagger, useAnimate } from "framer-motion";
import { cn } from "@/lib/utils";

export const TextGenerateEffect = ({
  words,
  className,
}: {
  words: string;
  className?: string;
}) => {
  const [scope, animate] = useAnimate();
  let wordsArray = words.split(" ");
  useEffect(() => {
    animate(
      "span",
      {
        opacity: 1,
      },
      {
        duration: 2,
        delay: stagger(0.2),
      }
    );
  }, [animate]);

  const renderWords = () => {
    const lines = words.split(" * "); 
  
    return (
      <motion.div ref={scope}>
        {lines.map((line, idx) => (
          <div key={idx} className="block">
            {line.split(" ").map((word, wIdx) => (
              <motion.span
                key={word + wIdx}
                className={`opacity-0 ${idx === 1 ? "text-black dark:text-white" : "text-black dark:text-white"}`}
              >
                {word}{" "}
              </motion.span>
            ))}
          </div>
        ))}
      </motion.div>
    );
  };
  

  return (
    <div className={cn("font-bold", className)}>
      <div>
        <div className=" text-white leading-snug">{renderWords()}</div>
      </div>
    </div>
  );
};
